import { useState, useCallback, useEffect } from 'react'
import { useDispatch, useSelector, shallowEqual } from 'react-redux'
import { Stack, Text } from '@leroy-merlin-br/backyard-react-ui'

import { Actions as CouponActions } from 'checkout/redux/modules/coupon'
import { Notification } from 'checkout/components/Notification'
import { ConditionsOfUse } from 'checkout/components/ConditionsUse'
import { Coupon } from 'checkout/components/Coupon'
import { PriceTag } from 'checkout/components/Icons'

import * as Utils from './utils'

const CouponContainer = ({
  hasService = false
}) => {
  const [propsCoupon, setPropsCoupon] = useState({})
  const { data, isRequest, error } = useSelector(
    state => state.coupon,
    shallowEqual
  )

  const dispatch = useDispatch()

  const handleSetCoupon = useCallback(
    data => dispatch(CouponActions.setCoupon(data)),
    [dispatch]
  )

  const handleApplyCoupon = useCallback(
    code => dispatch(CouponActions.applyCoupon(code)),
    [dispatch]
  )

  const handleRemoveCoupon = useCallback(
    code => dispatch(CouponActions.removeCoupon(code)),
    [dispatch]
  )

  useEffect(() => {
    if (data) {
      return setPropsCoupon({
        handleCoupon: () => handleRemoveCoupon(data.code),
        isDisabled: true,
        tagData: {
          label: data.code,
          type: Utils.isLoyalty(data) ? 'loyalty' : 'success',
          icon: PriceTag
        }
      })
    }

    setPropsCoupon({
      handleCoupon: code => handleApplyCoupon(code)
    })
  }, [data, handleRemoveCoupon, handleApplyCoupon])

  useEffect(() => {
    const couponAppliedInTwig = localStorage.getItem('@checkout:coupon')

    if (couponAppliedInTwig) {
      handleSetCoupon({ code: couponAppliedInTwig, type: 'product' })
    }
  }, [handleSetCoupon])

  return (
    <Stack spacing="mega">
      <Coupon
        hasLoading={isRequest}
        hasError={Boolean(error)}
        hasService={hasService}
        {...propsCoupon}
      />

      {error && (
        <Notification type="danger">
          <Text size="kilo" noMargin>
            {Utils.getMessageByStatus(error)}
          </Text>
        </Notification>
      )}

      <ConditionsOfUse hasService={hasService} />
    </Stack>
  )
}

export default CouponContainer
